module.exports = __webpack_public_path__ + "img/gear.855a5755.svg";